import React from "react";

import { Button } from "../../Button";
import { Image } from "../../Image";
import { Text } from "../../Text";
import { TextTypes, TextColors } from "../../constants";

import "./styles.scss";

// Relates to: Self Signup

export const VerifyInsuranceAccepted = ({
  copayAmount,
  insuranceLogo,
  insuranceName,
  onClick,
  planName,
  title,
}) => {
  return (
    <div className="apti-VerifyInsurance">
      <Text color={TextColors.green} type={TextTypes.heading1}>
        {title}
      </Text>
      {insuranceLogo && <Image alt="insurance logo" className="logo" src={insuranceLogo}></Image>}
      <Text style={{ color: TextColors.grey }}>{planName}</Text>

      {copayAmount > 0 && (
        <>
          <Text className="copayTitle">
            Your plan has a <Text className="bold">{"$" + copayAmount}</Text> copay.
          </Text>
        </>
      )}
      {copayAmount === null && (
        <>
          <Text className="copayDescription">
            Your plan may have coinsurance or deductibles. Refer to your insurance card or contact{" "}
            <Text className="bold">{insuranceName}</Text> for details.
          </Text>
        </>
      )}

      <Button buttonType="primary" onClick={onClick}>
        Continue
      </Button>

      {copayAmount !== null && (
        <>
          <Text className="copay-disclaimer" style={{ color: TextColors.grey }}>
            Based on your benefits, you may have additional costs associated with your care. Please
            contact <span style={{ fontWeight: 900 }}>{insuranceName}</span> for more information.
          </Text>
        </>
      )}
    </div>
  );
};

VerifyInsuranceAccepted.defaultProps = {
  copayAmount: null,
  insuranceLogo: "",
  insuranceName: "",
  onClick: () => {},
  planName: "",
  title: "",
};
